import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "items-container"
};
const _hoisted_2 = {
  class: "grid-view"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  style: {
    "text-align": "left"
  }
};
const _hoisted_5 = {
  key: 1,
  class: "empty-data-tips"
};
import { computed, ref } from 'vue';
import { ElButton, ElPopover } from 'element-plus';
import QuickSkillPreviewCard from "@/components/Stage/QuickSkillPreviewCard.vue";
export default {
  __name: 'QuickDicePicker',
  props: {
    data: {
      type: Object,
      required: true
    },
    translucent: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['diceEvent'],

  setup(__props, {
    emit: __emit
  }) {
    const dicePickerDict = [{
      'key': 'properties',
      'name': '属性'
    }, {
      'key': 'capabilities',
      'name': '能力'
    }, {
      'key': 'skills',
      'name': '技能'
    }]; // pre-declaration

    const props = __props;
    const emits = __emit; // refs

    const pickerTypeName = ref(dicePickerDict[0].name);
    const diceMode = ref(0);
    const times = ref(1);
    const degree = ref(1); // computed

    const pickerType = computed(() => {
      const item = dicePickerDict.find(item => item.name === pickerTypeName.value);
      if (!item) return null;
      return item.key;
    });
    const pickerData = computed(() => {
      if (!props.data || !pickerType.value) return null;
      const data = props.data[pickerType.value];
      if (!data || Object.keys(data).length === 0) return null;
      return data;
    }); // functions

    const getSliderName = () => {
      if (diceMode.value === 0) {
        return '连骰：';
      } else if (diceMode.value === 1) {
        return '优势：';
      } else if (diceMode.value === -1) {
        return '劣势：';
      }

      return '';
    };

    const resetConfig = () => {
      diceMode.value = 0;
      times.value = 1;
      degree.value = 1;
    };

    const clickItem = key => {
      // console.log('clickRole', roleId)
      let content = '';

      if (diceMode.value === 0) {
        content = `.ra ${key}`;

        if (times.value !== 1) {
          content = `.ra${times.value} ${key}`;
        }
      } else {
        const symbol = diceMode.value === 1 ? 'rab' : 'rap';
        content = `.${symbol} ${key}`;

        if (degree.value > 1) {
          content = `.${symbol}${degree.value + 1} ${key}`;
        }
      }

      emits('diceEvent', content);
    };

    return (_ctx, _cache) => {
      const _component_el_segmented = _resolveComponent("el-segmented");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_slider = _resolveComponent("el-slider");

      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["picker-container", __props.translucent ? 'translucent' : ''])
      }, [_createVNode(_component_el_row, {
        class: "operator-row"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_segmented, {
          modelValue: pickerTypeName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => pickerTypeName.value = $event),
          options: dicePickerDict.map(item => item.name),
          block: ""
        }, null, 8, ["modelValue", "options"])]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "operator-row"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElButton), {
          onClick: resetConfig
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("恢复默认设置", -1)]))]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "operator-row"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_group, {
          modelValue: diceMode.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => diceMode.value = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            value: -1
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("劣势检定", -1)]))]),
            _: 1
          }), _createVNode(_component_el_radio, {
            value: 0
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("常规", -1)]))]),
            _: 1
          }), _createVNode(_component_el_radio, {
            value: 1
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("优势检定", -1)]))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "operator-row"
      }, {
        default: _withCtx(() => [_createElementVNode("text", null, _toDisplayString(getSliderName()), 1), diceMode.value === 0 ? (_openBlock(), _createBlock(_component_el_slider, {
          key: 0,
          modelValue: times.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => times.value = $event),
          min: 1,
          max: 5,
          step: 1
        }, null, 8, ["modelValue"])) : [1, -1].includes(diceMode.value) ? (_openBlock(), _createBlock(_component_el_slider, {
          key: 1,
          modelValue: degree.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => degree.value = $event),
          min: 1,
          max: 3,
          step: 1
        }, null, 8, ["modelValue"])) : _createCommentVNode("", true)]),
        _: 1
      }), pickerData.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pickerData.value, (item, key, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "item-card",
          onClick: $event => clickItem(key)
        }, [pickerType.value === 'skills' ? (_openBlock(), _createBlock(_unref(ElPopover), {
          key: 0,
          width: "420px",
          placement: "right",
          trigger: "hover",
          "popper-class": "stage-popper"
        }, {
          reference: _withCtx(() => [_createVNode(_component_el_row, {
            style: {
              "justify-content": "space-between"
            }
          }, {
            default: _withCtx(() => [_createElementVNode("text", _hoisted_4, [_createElementVNode("b", null, _toDisplayString(key), 1)]), _createElementVNode("text", null, _toDisplayString(item?.value ?? '未知数值'), 1)]),
            _: 2
          }, 1024)]),
          default: _withCtx(() => [_createVNode(QuickSkillPreviewCard, {
            "skill-id": item.id
          }, null, 8, ["skill-id"])]),
          _: 2
        }, 1024)) : (_openBlock(), _createBlock(_component_el_row, {
          key: 1,
          style: {
            "justify-content": "space-between"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("text", null, [_createElementVNode("b", null, _toDisplayString(key), 1)]), _createElementVNode("text", null, _toDisplayString(item?.value ?? '未知数值'), 1)]),
          _: 2
        }, 1024))], 8, _hoisted_3);
      }), 128))])])) : (_openBlock(), _createElementBlock("div", _hoisted_5, " 没有检测到可用的快速检定项 "))], 2);
    };
  }

};